import {activeLanguage,languageInfo} from '../shared/services/localization';
import {environment} from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TenantService } from './tenant.service';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {
  constructor(private tenantService: TenantService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let headers = this.tenantService.addTenantToHeaders(request.headers);
    if(request.method==='GET'&&request.url.startsWith(environment.apiHost+'/')){
      let language=activeLanguage().code;try{language=languageInfo(localStorage.getItem('Language')||language).code;}catch{}
      headers=headers.set('X-Resource-Language',language);
    }

    request = request.clone({
      headers: headers,
    });
    return next.handle(request);
  }
}
